<div class="finalize-user-section">
  <span class="finalize-user-section__header">
    {{ 'general.staff' | translate }}
  </span>
  <div>
    @for (userId of usersFromTrainingsToFinalize$ | async; track userId) {
      <nz-tag>{{ userId | userName | async }}</nz-tag>
    }
  </div>
</div>
